import React from 'react'
import { ContextProvider } from './context/ContextProvider'
import MainHome from './localstorge/MainHome'
import TopicsHome from './components/TopicsHome'
import { FirebaseAppProvider } from './context/FirebaseContextProvider'

const Firebase = () => {
  return (
    //  <ContextProvider>
    //      <MainHome/>

    //   </ContextProvider>
    <>
      <FirebaseAppProvider>
        <TopicsHome />
      </FirebaseAppProvider>

    </>
  )
}

export default Firebase